import React from "react";
import { Routes, Route } from "react-router";
import routes from "./constants/routes.json";
import ProtectedRouter from "./views/ProtectedRouter.js";
import LoginPage from "./views/LoginPage";
import Home from "./views/Home";
import Password from "./views/Password.js";
import Password2 from "./views/Password2.js";
import Password3 from "./views/Password3.js";
import Password4 from "./views/Password4.js";
import Password5 from "./views/Password5.js";
import Password6 from "./views/Password6.js";
import Reportes from "./views/Reportes";
import StockTienda from "./views/StockTienda";
import StockTienda2 from "./views/StockTienda2";
import StockProvider from "./views/StockProvider";
import PedidoSelect from "./views/PedidoSelect";
import PedidoSelect2 from "./views/PedidoSelect2";
import PedidoTienda from "./views/PedidoTienda.js";
import VerPedidoTienda from "./views/VerPedidoTienda.js";
import FirmaPdf from "./views/FirmaPdf";
import Formato from "./views/Formato";
import PDF from "./views/PDF";
import PDF2BUSCADOR from "./views/Pdf2Buscador.js";
import PdfViewer2 from "./views/PdfViewer22.js";
import Layout from "./views/Layout.js";
import PedidoSelectForm2 from "./components/PedidoSelectForm2.js";
import Administrador from "./views/Administrador.js";
import VerPedidoSelectForm from "./components/VerPedidoSelectForm.js";

function App() {
  const pdfLink =
    "https://www.turnerlibros.com/wp-content/uploads/2021/02/ejemplo.pdf";

  return (
    <>
      <Routes>
        <Route exact path={routes.LOGIN} element={<LoginPage />} />
        <Route
          exact
          path={routes.LOGIN}
          element={
            <ProtectedRouter>
              <Layout />
            </ProtectedRouter>
          }>
          <Route path={routes.HOME} element={<Home />} />
          <Route path={routes.PASSWORD} element={<Password />} />
          <Route path={routes.REPORTERECEPCION} element={<Password2 />} />
          <Route path={routes.REPORTERECEPCION2} element={<Password3 />} />
          <Route path={routes.VERREPORTESRECEPCION} element={<Password6 />} />
          <Route
            path={routes.FORMULARIOFORMATORECEPCION}
            element={<Password4 />}
          />
          <Route
            path={routes.REPORTERECEPCIONCARGAEVIDENCIAS}
            element={<Password5 />}
          />

          <Route path={routes.REPORTES} element={<Reportes />} />
          <Route path={routes.STOCKTIENDA} element={<StockTienda />} />
          <Route path={routes.STOCKTIENDA2} element={<StockTienda2 />} />
          <Route path={routes.INVENTARIO} element={<StockProvider />} />
          <Route path={routes.FORMATO} element={<Formato />} />
          <Route path={routes.PEDIDOSELECT} element={<PedidoSelect />} />
          <Route
            path={routes.TIENDASELECTFORMATO}
            element={<PedidoSelectForm2 />}
          />
          <Route path={routes.PDF} element={<PDF pdfLink />} />
          <Route path={routes.BUSCADORCONTRATOS} element={<PDF2BUSCADOR />} />
          <Route path={routes.PRUEBA2} element={<FirmaPdf />} />
          <Route path={routes.PEDIDOTIENDA} element={<PedidoTienda />} />
                <Route path={routes.VERPEDIDOTIENDA} element={<VerPedidoTienda />} />
          <Route
            path={routes.SELECTPEDIDOS}
            element={<VerPedidoSelectForm />}
          />

          <Route path={routes.VISUALIZADOR2} element={<PdfViewer2 />} />
          <Route path={routes.ADMIN} element={<Administrador />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
